import { connect } from 'react-redux'
import { message } from '../../redux/actions'
import Component from '../component'

/**
 * This is the Game restored prompt, should be used when the player
 * returns to a game that didn't get properly finished.
 */
@connect(state => ({ base: state.base }), { setMessage: message })
export default class GameRestorePrompt extends Component {
  /**
   * Renders out a message popup as DOM element, displaying a "Game round in progress" prompt.
   * @returns {*}
   */
  render() {
    const { setMessage } = this.props
    return (
      <div className="popup-content">
        <div className="popup-message">{ this.t('connectionLost.message') }</div>
        <br />
        <div className="buttonContainer">
          <button onClick={() => setMessage(null)}>
            { this.t('realityCheck.ok') }
          </button>
        </div>
      </div>
    )
  }
}
